import HotelDealItem from "./HotelDealItem"
import UnsupportedDealItem from "./UnsupportedDealItem"
import FlightDealItem from "../FlightDealItem"

type FlashSaleDealItemProps = {
  item: any;
  className?: string;
  itemType?: "sample" | "default";
};

const FlashSaleDealItem = ({ item, className, itemType }: FlashSaleDealItemProps) => {
  if (item?.productType === 'HOTEL') {
    return <HotelDealItem data={item} className={className} itemType={itemType} />
  }

  if (item?.productType === 'FLIGHT') {
    return <FlightDealItem deal={item} variant="poster" className={className} />
  }

  return <UnsupportedDealItem productType={item?.productType} className={className} />
}

export default FlashSaleDealItem
